"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _heatmapDataSeries = _interopRequireDefault(require("./heatmapDataSeries.js"));

var _heatmapAxisCategories = require("./heatmapAxisCategories");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = function _default(_ref) {
  var allRows = _ref.allRows,
      geneQuery = _ref.geneQuery,
      columnHeaders = _ref.columnHeaders,
      experiment = _ref.experiment,
      inProxy = _ref.inProxy,
      atlasUrl = _ref.atlasUrl,
      pathToResources = _ref.pathToResources;
  return {
    xAxisCategories: (0, _heatmapAxisCategories.getHeatmapXAxisCategories)({
      columnHeaders: columnHeaders,
      experiment: experiment,
      inProxy: inProxy,
      atlasUrl: atlasUrl,
      pathToResources: pathToResources
    }),
    yAxisCategories: (0, _heatmapAxisCategories.getHeatmapYAxisCategories)({
      rows: allRows,
      geneQuery: geneQuery,
      experiment: experiment,
      inProxy: inProxy,
      atlasUrl: atlasUrl
    }),
    dataSeries: (0, _heatmapDataSeries["default"])(allRows, experiment)
  };
};

exports["default"] = _default;